// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PAudioOutlinedSvg from "@fishx/icons-svg/es/asn/PAudioOutlined";
import FishxIcon from '../components/FishxIcon';

var PAudioOutlined = function PAudioOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PAudioOutlinedSvg
  }));
};

PAudioOutlined.displayName = 'PAudioOutlined';
export default React.forwardRef(PAudioOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PAudioOutlined.js
// module id = 3226
// module chunks = 0